import { ActionTree } from "vuex";
import { IReportState } from "../states.store";

const notificationsActions = <ActionTree<IReportState, any>>{
};

export default notificationsActions;
